import script from "./SizeEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./SizeEditor.vue?vue&type=script&setup=true&lang=js"

import "./SizeEditor.vue?vue&type=style&index=0&id=64e1a232&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64e1a232"]])

export default __exports__